import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

// Services
import { BffCommunicationService } from '../services/_index';

@Injectable()
export class MpmJwtHttpInterceptor implements HttpInterceptor {
  private readonly MPM_JWT_HEADER = 'x-desj-mpm-token';
  private readonly IGNORED_URLS = ['/assets/i18n'];
  constructor(private readonly _bffService: BffCommunicationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.hasIgnoredUrl(req)) {
      return next.handle(req);
    }

    // On laisse passer le call session (pour ne pas avoir de boucle circulaire)
    if (this.hasContextSessionUrl(req)) {
      return next.handle(req);
    }

    const newRequest = this.prepareMpmJwtHeader(req);

    return next.handle(newRequest);
  }

  public prepareMpmJwtHeader(req: HttpRequest<any>): HttpRequest<any> {
    let newHeaders = req.headers;
    let newRequest: HttpRequest<any> = null;

    const mpmJwt = this._bffService.getMpmJwt();
    if (mpmJwt) {
      // Add into the header
      newHeaders = newHeaders.set(this.MPM_JWT_HEADER, mpmJwt);
    } else {
      // Delete the header if it does exist as the token isn't there
      if (req.headers.has(this.MPM_JWT_HEADER)) {
        newHeaders = newHeaders.delete(this.MPM_JWT_HEADER);
      }
    }
    newRequest = req.clone({
      headers: newHeaders
    });

    return newRequest;
  }

  public hasContextSessionUrl(req: HttpRequest<any>): boolean {
    return req.url.indexOf(`/api/contextes/session`) > 0;
  }

  public hasIgnoredUrl(req: HttpRequest<any>): boolean {
    let hasIgnoredUrl = false;

    this.IGNORED_URLS.forEach(ignoredUrl => {
      if (req.url.indexOf(ignoredUrl) > -1) {
        hasIgnoredUrl = true;
      }
    });

    return hasIgnoredUrl;
  }
}
